// @flow
import * as React from 'react';
import ResponsiveContext from './responsiveContext';

function Responsiveness(WrappedComponent: React.ComponentType<*>) {
  class Responsive extends React.Component<*> {
    render() {
      const { forwardRef, ...rest } = this.props;
      return (
        <ResponsiveContext.Consumer>
          {responsive => <WrappedComponent ref={forwardRef} {...rest} responsive={responsive} />}
        </ResponsiveContext.Consumer>
      );
    }
  }

  //$FlowFixMe
  return React.forwardRef((props: *, ref: *) => {
    return <Responsive {...props} forwardRef={ref} />;
  });
}
export default Responsiveness;
